// 获取模块主要获取数据模块
import request from '@/utils/request';
// 获取数据
// export const getSomeData = (param) => request({url: `/look/userManagement/getUserManagementBatchInfo?current=${param.current}&size=${param.size}`, methods: 'get'});
export const getSomeData = (param) =>
    request({
        url: `/look/userManagement/getUserManagementBatchInfo?current=${param.current}&size=${param.size
            }${param.nameOrCode ? `&nameOrCode=${param.nameOrCode}` : ''}&state=${param.state
            }${param.startGoldNumber ? `&startGoldNumber=${param.startGoldNumber}` : ''}${param.endGoldNumber ? `&endGoldNumber=${param.endGoldNumber}` : ''}`,
        methods: 'get',
    });
// 获取查看详情数据
export const getUserInfo = (openId) => request({url: `/look/userManagement/getUserManagementById?openId=${openId}`, method: 'get'});
// switch按钮
export const handleSwitch = (switchData) => request({ url: '/look/userManagement/updateUserManagementById', method: 'put', data: switchData });


// 获取用户录音列表
export const getUserAudioList = (userId, size, current) => request({url: `/look/userManagement/getUserHistoryList?userId=${userId}&size=${size}&current=${current}`, method: 'get'});